// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YgPR","col":"styles_col__9GW3G"};